
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  GetDeptData,
  GetSystemList,
  PatchDeptDetail,
  PostAddDept,
} from "@/request/common";
import { BuildTree } from "@/utils/base";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
import Empty from "@/components/empty.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Empty,
  },
})
export default class Name extends Vue {
  private list: any[] = [];
  private filter: any = {
    search: "",
  };
  private ifShowSelectXitong: boolean = false;
  private ifShowAddSub: boolean = false;
  private tempSub: any = {
    坐标: ["", ""],
  };
  private selectData: any = {};
  private types: any = [];
  private jingweiInput(e: any) {
    this.$forceUpdate();
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  private openSelect(item: any) {
    this.selectData = JSON.parse(JSON.stringify(item));
    this.ifShowSelectXitong = true;
  }
  private selectSure() {
    this.ifShowSelectXitong = false;
  }
  /**
   * @description 获取列表数据
   */
  private fetchList() {
    const params: any = {
      params: {},
    };
    GetDeptData(this, params).then((data: any) => {
      this.list = BuildTree(data.data);
    });
  }
  /**
   * @description 打开添加下级部门弹窗
   */
  private openAddSub(inti: any) {
    this.tempSub = {
      parent_institution_id: inti.institution_id,
      level: inti.level + 1,
      上级名称: inti["名称"],
      坐标: ["", ""],
    };
    this.ifShowAddSub = true;
  }
  /**
   * @description 打开编辑下级部门弹窗
   */
  private openComposeSub(inti: any) {
    this.tempSub = JSON.parse(JSON.stringify(inti));
    this.ifShowAddSub = true;
  }
  /**
   * @description 新建或编辑下属部门
   */
  private saveSub() {
    if (!this.tempSub.name) {
      this.$message.warning("请输入部门名称");
      return;
    }
    const params: any = {
      name: this.tempSub.name,
      description: this.tempSub.description,
    };
    PatchDeptDetail(this, this.tempSub.id, params).then((data: any) => {
      this.$message.success("保存成功");
      this.ifShowAddSub = false;
      this.fetchList();
    });
  }
  private getTypes() {
    const params: any = {
      params: {
        ordering: "create_datetime",
      },
    };
    GetSystemList(this, params).then((res: any) => {
      this.types = res.data;
    });
  }
  mounted() {
    this.fetchList();
    this.getTypes();
  }
}
